import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CTA = () => {
  const { t } = useTranslation();

  const trustItems = [
    { icon: 'ri-shield-check-line', textKey: 'cta.trust1' },
    { icon: 'ri-time-line', textKey: 'cta.trust2' },
    { icon: 'ri-customer-service-2-line', textKey: 'cta.trust3' },
    { icon: 'ri-award-line', textKey: 'cta.trust4' },
  ];

  return (
    <section className="relative py-28 overflow-hidden bg-gray-950">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3112a72de2320882892a958ebfd08e29.jpg"
          alt=""
          width={1280}
          height={500}
          className="w-full h-full object-cover opacity-30"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950 via-gray-950/80 to-gray-950"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-transparent to-gray-950/50"></div>
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 h-64 bg-brand-red/20 blur-3xl rounded-full pointer-events-none"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-brand-red/20 border border-brand-red/30 rounded-full px-5 py-2 mb-8">
          <i className="ri-rocket-line text-brand-red text-sm"></i>
          <span className="text-brand-red text-sm font-semibold">{t('cta.badge')}</span>
        </div>

        <h2 className="text-5xl md:text-6xl font-black text-white leading-tight mb-6">
          {t('cta.title1')}
          <span className="block text-brand-red">{t('cta.title2')}</span>
        </h2>

        <p className="text-gray-400 text-lg leading-relaxed mb-12 max-w-2xl mx-auto">
          {t('cta.desc')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact">
            <button className="group px-8 py-4 bg-brand-red hover:bg-brand-red-dark text-white font-bold rounded-xl text-base transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer flex items-center gap-3">
              {t('cta.btn1')}
              <span className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full group-hover:translate-x-1 rtl:group-hover:-translate-x-1 transition-transform">
                <i className="ri-arrow-right-line rtl:rotate-180 text-sm"></i>
              </span>
            </button>
          </Link>
          <Link to="/join">
            <button className="px-8 py-4 border border-white/20 text-white hover:bg-white/10 hover:border-white/40 backdrop-blur-sm font-semibold rounded-xl text-base transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2">
              <i className="ri-team-line text-lg"></i>
              {t('cta.btn2')}
            </button>
          </Link>
        </div>

        <div className="mt-14 pt-10 border-t border-white/10 flex flex-wrap justify-center gap-8 text-gray-500 text-sm">
          {trustItems.map((item) => (
            <div key={item.textKey} className="flex items-center gap-2">
              <i className={`${item.icon} text-brand-red`}></i>
              <span>{t(item.textKey)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTA;
